import React from "react";
import { injectIntl, WrappedComponentProps } from "react-intl";
import SignedContract from "./SignedContract";
import { OnboardingInfo } from "../../graphql/onboarding/onboarding/types/OnboardingInfo";
import { ONBOARDING } from "../../graphql/onboarding/onboarding/query";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GENDER_ITEMS } from "../../utils/constant";
import { Box, CircularProgress } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import {
  CheckPaymentStripe,
  CheckPaymentStripeVariables,
} from "../../graphql/onboarding/stripe/types/CheckPaymentStripe";
import { CHECK_PAYMENT_STRIPE } from "../../graphql/onboarding/stripe/query";
import { Payment_Status } from "../../enums/stripe";
import StatusGetID from "../GetId/statusGetId";
import Layout from "../Common/NewLayout";
import Header from "../Common/NewLayout/Header";
import { useToastNotifications } from "../../utils/toastUtils";

const SignedContractProvider = ({ intl }: WrappedComponentProps) => {
  const navigate = useNavigate();
  const { showErrorToast } = useToastNotifications();
  const { data: onboarding, loading } = useQuery<OnboardingInfo>(ONBOARDING, {
    fetchPolicy: "network-only",
    onCompleted: () => {
      checkPayment();
    },
    onError: () => {
      showErrorToast({
        description: `onboarding.retrieving.information.error`,
      });
    },
  });

  const { active, loading: loadingGetId } = StatusGetID();

  const [checkPayment, { loading: checkStripeLoading }] = useLazyQuery<
    CheckPaymentStripe,
    CheckPaymentStripeVariables
  >(CHECK_PAYMENT_STRIPE, {
    variables: { changeStep: false },
    onCompleted: (data) => {
      if (data?.checkPaymentStripe === Payment_Status.PAID) {
        return data.checkPaymentStripe;
      } else {
        showErrorToast({
          description: `payment.stripe.not.paid`,
        });
        returnPreviousHistory();
      }
    },
    onError: () => {
      showErrorToast({
        description: `check.payment.stripe.status.error`,
      });
      returnPreviousHistory();
    },
  });

  const isIndividual = onboarding?.onboardingInfo?.company?.isIndividual;
  const returnPreviousHistory = () => {
    setTimeout(() => {
      navigate(isIndividual ? "/manager" : "/shareholdersPercent");
    }, 5000);
  };

  if (loading || checkStripeLoading || loadingGetId) {
    return (
      <Box position="absolute" top="50%" left="50%">
        <CircularProgress />
      </Box>
    );
  }

  let title = "";
  if (onboarding?.onboardingInfo?.legalRepresentative) {
    const { gender, firstname, name } =
      onboarding.onboardingInfo.legalRepresentative;
    const result = GENDER_ITEMS.find((item) => item.id === gender);
    title = `${result?.label || ""} ${firstname || ""} ${name || ""}`;
  }

  return (
    <Layout
      title="Signature"
      description="Consultez les conditions et signez pour finaliser votre inscription. Cette étape conclut votre parcours et vous ouvre l'accès à un univers de services innovants."
      loading={loading || checkStripeLoading || loadingGetId}
    >
      <Header
        title="Contrat"
        description="Veuillez signer numériquement votre contrat en cliquant sur le bouton contrat."
      />
      <SignedContract
        previous={
          active
            ? "/identity-verification"
            : isIndividual
            ? "/manager"
            : "/shareholdersPercent"
        }
        title={title}
      />
    </Layout>
  );
};

export default injectIntl(SignedContractProvider);
